import './close-button.css';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function CloseButton({ onClickHandler, isDisabled = false, theme = 'light' }) {
	return (
		<button class="button-close" disabled={isDisabled} tabIndex={isDisabled ? '-1' : false} onClick={onClickHandler}>
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				width="30px"
				height="30px"
				viewBox="0 0 30 30"
				enable-background="new 0 0 30 30"
				xmlSpace="preserve"
			>
				<title>{__('close', 'real-estate-project')}</title>
				<polygon fill={theme === 'light' ? '#fff' : '#000'} points="30,2.8 27.2,0 15,12.2 2.8,0 0,2.8 12.2,15 0,27.2 2.8,30 15,17.8 27.2,30 30,27.2 17.8,15" />
			</svg>
		</button>
	);
}
